document.addEventListener('DOMContentLoaded', function () {
  // Only run on collection pages
  if (!window.location.pathname.includes('/collections/')) return;

  let lastUrl = location.href;

  function addInStockIfNeeded() {
    try {
      const url = new URL(window.location.href);
      const params = url.searchParams;

      // Only apply "In Stock" if not already active
      if (!params.has('filter.v.availability')) {
        params.set('filter.v.availability', '1');
        const newUrl = url.pathname + '?' + params.toString();

        const lastRedirect = sessionStorage.getItem('autoInstockRedirect') || '';
        if (lastRedirect !== newUrl) {
          sessionStorage.setItem('autoInstockRedirect', newUrl);
          window.location.replace(newUrl);
        }
      }
    } catch (err) {
      console.error('addInStockIfNeeded error', err);
    }
  }

  // Detect real filter selection clicks (not opening menus)
  document.body.addEventListener('click', function (e) {
    const el = e.target.closest && e.target.closest('a, label, input');
    if (!el) return;

    const href = el.getAttribute && el.getAttribute('href');
    const name = el.getAttribute && el.getAttribute('name');

    // Only trigger for actual filter elements
    if (
      (href && href.includes('filter.')) ||
      (name && name.startsWith('filter'))
    ) {
      // Wait for Shopify to update the URL first
      const checkUrlChange = setInterval(() => {
        if (window.location.href !== lastUrl) {
          clearInterval(checkUrlChange);
          lastUrl = window.location.href;
          setTimeout(addInStockIfNeeded, 200); // delay ensures the new filter is applied first
        }
      }, 100);
    }
  }, true);

  // Clean redirect flag if availability already applied
  if (new URL(location.href).searchParams.has('filter.v.availability')) {
    sessionStorage.removeItem('autoInstockRedirect');
  }
});
